// 好友代付
export default [{
    path: '/pay/invite-paid/:id',
    name: 'PayInvitePaid',
    component: () => import('@/views/pay/invite_paid')
},{
    path: '/pay/help-pay/:id/:type/:api',
    name: 'PayHelpPay',
    component: () => import('@/views/pay/help_pay')
},{
    path: '/pay/help-pay-success/:price',
    name: 'PayHelpPaySuccess',
    component: () => import('@/views/pay/help_pay_success')
}]



// WEBPACK FOOTER //
// ./src/router/pay.js